// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q5-9";
export var arrowButtonContainer = "_q5-5";
export var arrowButtonIcon = "_q5-6";
export var carouselArrowButton = "_q5-2";
export var carouselElementContainer = "_q5-1";
export var currentSlide = "_q5-8";
export var left = "_q5-3";
export var otherSlide = "_q5-a";
export var productCarouselContainer = "_q5-0";
export var right = "_q5-4";
export var sliderOverflow = "_q5-7";